import React from 'react';
import PropTypes from 'prop-types';
import { slugify } from '../../../utils/slugify';
import { sessionStorage } from 'dibs-browser-storage';
import { trackFilterClick } from '../../../utils/tracking/searchBrowse/filterTracking';

// components
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';

// styles
import styles from './SbSharedRefineMenuFacet.scss';

export const SESSION_STORAGE_KEY = 'facetMenu';

class SbSharedRefineMenuFacet extends React.Component {
    constructor(props) {
        super(props);

        this.state = { expanded: !!this.props.initiallyExpanded };
        this.onLabelClick = this.onLabelClick.bind(this);
    }

    componentDidMount() {
        const { expanded } = this.state;
        const { storageFacetKey } = this.props;
        const sessionFacetMenu = sessionStorage.getItem(SESSION_STORAGE_KEY) || {};
        const isOpen = sessionFacetMenu[storageFacetKey];

        if (isOpen !== undefined && expanded !== isOpen) {
            this.setState({ expanded: isOpen });
        }
    }

    onLabelClick() {
        const { storageFacetKey } = this.props;
        const sessionFacetMenu = sessionStorage.getItem(SESSION_STORAGE_KEY) || {};

        this.setState({ expanded: !this.state.expanded }, () => {
            sessionStorage.setItem(
                SESSION_STORAGE_KEY,
                Object.assign(sessionFacetMenu, { [storageFacetKey]: this.state.expanded })
            );
            trackFilterClick(this.props.title, !this.state.expanded);
        });
    }

    render() {
        const { title, children, coachmark } = this.props;
        const { expanded } = this.state;

        const showCoachmark = coachmark && expanded;

        return (
            <ExpandingArea
                label={title}
                onClick={this.onLabelClick}
                dataTn={`facet-${slugify(title)}`}
                expanded={expanded}
                wrapperClass={styles.container}
                labelClass={styles.title}
            >
                <div className={styles.facetContent} data-tn={`facet-container-${slugify(title)}`}>
                    {children}

                    {/* coachmark is needed specifically for the responsive price range filter - TRADE-2828 */}
                    {showCoachmark && coachmark}
                </div>
            </ExpandingArea>
        );
    }
}

SbSharedRefineMenuFacet.defaultProps = {
    initiallyExpanded: true,
};

SbSharedRefineMenuFacet.propTypes = {
    initiallyExpanded: PropTypes.bool,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    coachmark: PropTypes.node,
    storageFacetKey: PropTypes.string.isRequired,
};

export { SbSharedRefineMenuFacet };
